import formStyles from "../../../GeneralStyles/formStyle";
const useStyles = (theme) => ({
  ...formStyles(theme),
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  termsHelperText: {
    paddingLeft: theme.spacing(4),
  },
});

export default useStyles;
